import Radio from './radio';
import Group from './group';
import Button from './radioButton';
Radio.Button = Button;
Radio.Group = Group;
export { Button, Group };
export default Radio;


//////////////////
// WEBPACK FOOTER
// ./node_modules/.3.6.1@antd/es/radio/index.js
// module id = 118
// module chunks = 1